function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _constant from 'lodash/constant';
import _mapValues from 'lodash/mapValues';
var STATE_DEFAULT = {};
export var PLOT_CHECKBOX_UPDATE = 'PLOT_CHECKBOX_UPDATE';
export var PLOT_CHECKBOX_UPDATE_ALL = 'PLOT_CHECKBOX_UPDATE_ALL';
export var PLOT_CHECKBOX_CLEAR_ALL = 'PLOT_CHECKBOX_CLEAR_ALL';
export default function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PLOT_CHECKBOX_UPDATE:
      return Object.assign({}, state, _defineProperty({}, action.plotId, Object.assign({}, state[action.plotId], _defineProperty({}, action.checkboxId, !!action.checked))));

    case PLOT_CHECKBOX_UPDATE_ALL:
      return Object.assign({}, state, _defineProperty({}, action.plotId, action.checkedIdMap));

    case PLOT_CHECKBOX_CLEAR_ALL:
      return Object.assign({}, state, _defineProperty({}, action.plotId, _mapValues(state[action.plotId], _constant(false))));

    default:
      return state;
  }
}